// styles/components.js
import styled, { css } from "styled-components";

export const baseButtonStyles = css`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: ${(props) => `${props.theme.spacing.sm} ${props.theme.spacing.lg}`};
	border-radius: ${(props) => props.theme.borderRadius.md};
	font-weight: ${(props) => props.theme.typography.weights.medium};
	font-size: ${(props) => props.theme.typography.sizes.md};
	transition: all ${(props) => props.theme.transitions.normal};
	min-width: 120px; // Add minimum width
	border: none;
	cursor: pointer;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const Button = styled.button`
	${baseButtonStyles}

	${(props) => {
		switch (props.variant) {
			case "outlined":
				return css`
					border: 1px solid ${props.theme.colors.primary.main};
					color: ${props.theme.colors.primary.main};
					background: transparent;

					&:hover:not(:disabled) {
						background: ${props.theme.colors.primary.main}10;
					}
				`;
			case "text":
				return css`
					color: ${props.theme.colors.primary.main};
					background: transparent;

					&:hover:not(:disabled) {
						background: ${props.theme.colors.primary.main}10;
					}
				`;
			default:
				return css`
					background: ${props.theme.colors.primary.main};
					color: ${props.theme.colors.primary.contrast};

					&:hover:not(:disabled) {
						background: ${props.theme.colors.primary.dark};
					}
				`;
		}
	}}
`;

export const Input = styled.input`
	width: 100%;
	padding: ${(props) => props.theme.spacing.md};
	border: 1px solid ${(props) => props.theme.colors.text.disabled};
	border-radius: ${(props) => props.theme.borderRadius.md};
	font-size: ${(props) => props.theme.typography.sizes.md};
	transition: all ${(props) => props.theme.transitions.fast};

	&:focus {
		outline: none;
		border-color: ${(props) => props.theme.colors.primary.main};
		box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary.main}20;
	}

	&::placeholder {
		color: ${(props) => props.theme.colors.text.disabled};
	}

	&:disabled {
		background-color: ${(props) => props.theme.colors.background.alt};
		cursor: not-allowed;
	}
`;

export const Container = styled.div`
	width: 100%;
	max-width: ${(props) => props.theme.breakpoints.xl};
	margin: 0 auto;
	padding: 0 ${(props) => props.theme.spacing.md};

	@media (min-width: ${(props) => props.theme.breakpoints.sm}) {
		padding: 0 ${(props) => props.theme.spacing.lg};
	}
`;

export const Card = styled.div`
	background: ${(props) => props.theme.colors.background.paper};
	border-radius: ${(props) => props.theme.borderRadius.lg};
	box-shadow: ${(props) => props.theme.shadows.md};
	padding: ${(props) => props.theme.spacing.xl};
`;

export const Flex = styled.div`
	display: flex;
	gap: ${(props) => props.gap || props.theme.spacing.md};
	align-items: ${(props) => props.alignItems || "center"};
	justify-content: ${(props) => props.justifyContent || "flex-start"};
	flex-direction: ${(props) => props.direction || "row"};
	flex-wrap: ${(props) => props.wrap || "nowrap"};
`;

export const Grid = styled.div`
	display: grid;
	gap: ${(props) => props.gap || props.theme.spacing.md};
	grid-template-columns: ${(props) => props.columns || "repeat(12, 1fr)"};
	align-items: ${(props) => props.alignItems || "stretch"};
	justify-content: ${(props) => props.justifyContent || "stretch"};
`;
